import locationMissinglatlngComponent from './location.missinglatlng.component';

let locationMissinglatlngModule = angular.module('locationMissinglatlng', [
])

    .component('locationMissinglatlng', locationMissinglatlngComponent)

    .name;

export default locationMissinglatlngModule;


// WEBPACK FOOTER //
// ./client/app/components/location/missinglatlng/index.js